import { t } from 'i18next';
import './CardValue.css';
function CardValueDefaultProductWidget ({id, title, value, total, status}) {
    return (
        <div className="card-value-product" key={id}>
            <div className="title-card-value product-title-card">
                <label>{title}</label>
            </div>
            <p className='title-money-policy product-title-card-label'>{t("moneypolicy")}</p>
            <div className="money-card-value product-title-card">
                <label>{value}</label>
            </div>
            <div className="money-card-value product-title-card">
                <label>{t("vnd")}</label>
            </div>
            <p className='title-money-policy product-title-card-label'>{status ? t("feepolicy") : ""}</p>
            <div className="total-card-value product-desc-card" style={ status ? {display: "block"} : {display: "none"}}>
                <label>{total + " " + t("vnd") + " " + t("peryear")}</label>
            </div>
        </div>
    )
}

export default CardValueDefaultProductWidget;